import React from "react";

export default function Aviso() {
  return (
    <main className="min-h-screen py-16 px-4 sm:px-10 bg-[#111618] text-[#e6eef0]">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-white">Aviso de Privacidad</h1>
        <p className="text-sm text-text-muted-dark mb-6">
          <strong>Fecha de última actualización:</strong> 04 de noviembre de 2025
        </p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">1. Identidad y domicilio del Responsable</h2>
          <p className="text-text-muted-dark">
            El responsable del tratamiento de sus datos personales es <strong>TLC.MX</strong>, con domicilio en <strong>Av. Las Palmas 24, Del Carmen, 60952 Cdad. Lázaro Cárdenas, Mich.</strong>.
            Puede contactarnos a través del correo <strong>contacto@tlc.mx</strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">2. Datos personales que NO se recaban</h2>
          <p className="text-text-muted-dark mb-2"><strong>Esta página web NO recopila, almacena, trata ni transmite ningún tipo de dato personal.</strong></p>
          <ul className="list-disc list-inside text-text-muted-dark space-y-2">
            <li>No solicitamos nombres, correos electrónicos, números telefónicos, direcciones ni ningún otro dato identificable.</li>
            <li>No utilizamos formularios de contacto, registro de usuarios, suscripciones ni cookies de seguimiento.</li>
            <li>No empleamos herramientas de análisis (como Google Analytics) que requieran datos personales.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">3. Finalidad del sitio web</h2>
          <p className="text-text-muted-dark">
            El único propósito de esta página es <strong>proporcionar información sobre productos y servicios de comercio</strong>. Cuando desee cotizar, será redirigido directamente a <strong>WhatsApp</strong> mediante un enlace predefinido. <strong>Toda comunicación posterior ocurre exclusivamente en WhatsApp, fuera de nuestro sitio web.</strong>
          </p>
          <p className="text-text-muted-dark mt-2">
            <strong>Importante:</strong> Cualquier dato que comparta en WhatsApp será gestionado únicamente por Meta Platforms, Inc. (propietario de WhatsApp), conforme a su propia
            <a
              href="https://www.whatsapp.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary ml-1"
            >
              Política de Privacidad
            </a>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">4. Transferencia de datos</h2>
          <p className="text-text-muted-dark">No se realiza ninguna transferencia de datos personales, ya que no se recaban.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">5. Medios para ejercer derechos ARCO</h2>
          <p className="text-text-muted-dark">Dado que <strong>no se recaban datos personales</strong>, no es aplicable el ejercicio de derechos de Acceso, Rectificación, Cancelación u Oposición (ARCO).</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-2">6. Cambios al Aviso de Privacidad</h2>
          <p className="text-text-muted-dark">Cualquier modificación será publicada en esta misma página con la fecha de actualización correspondiente.</p>
        </section>

        <hr className="border-t border-t-[#283339] my-6" />

        <p className="text-text-muted-dark">
          <strong>Al continuar navegando en este sitio, usted acepta las condiciones descritas en este Aviso de Privacidad.</strong>
        </p>
        <p className="text-text-muted-dark mt-4 italic">Este sitio web opera con total transparencia y respeto a su privacidad. No guardamos nada, no rastreamos nada.</p>
      </div>
    </main>
  );
}